import { render, staticRenderFns } from "./userMember.vue?vue&type=template&id=4ae0dafa&scoped=true&"
import script from "./userMember.vue?vue&type=script&lang=js&"
export * from "./userMember.vue?vue&type=script&lang=js&"
import style0 from "./userMember.vue?vue&type=style&index=0&id=4ae0dafa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae0dafa",
  null
  
)

export default component.exports